import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiEmploymentData, type EnrollmentMultiEmploymentSubmitOutput } from '../../../../models'

export const getEnrollmentMultiEmploymentDataMock: EnrollmentMultiEmploymentData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/employment',
  enrollmentData: {
    applicationId: '12423478',
  },
}

export const submitEnrollmentMultiEmploymentDataMock: EnrollmentMultiEmploymentSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/finances',
}

export const mockGetEnrollmentMultiEmploymentData = graphql.mutation('getEnrollmentMultiEmploymentData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiEmploymentDataMock } })
})

export const mockSubmitEnrollmentMultiEmploymentData = graphql.mutation('submitEnrollmentMultiEmploymentData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiEmploymentDataMock } })
})

export const mockEnrollmentMultiEmployment = [
  mockGetEnrollmentMultiEmploymentData,
  mockSubmitEnrollmentMultiEmploymentData,
]
